import {
  GET_NETWORK_DOWNLOAD_TEMPLATE_REQUEST,
  GET_NETWORK_DOWNLOAD_TEMPLATE_SUCCESS,
  GET_NETWORK_DOWNLOAD_TEMPLATE_FAILURE,
  GET_NETWORK_LIST_REQUEST,
  GET_NETWORK_LIST_SUCCESS,
  GET_NETWORK_LIST_FAILURE,
  DELETE_NETWORK_LIST_REQUEST,
  DELETE_NETWORK_LIST_SUCCESS,
  DELETE_NETWORK_LIST_FAILURE,
  UPLOAD_NETWORK_DATA_REQUEST,
  UPLOAD_NETWORK_DATA_SUCCESS,
  UPLOAD_NETWORK_DATA_FAILURE,
} from "actions/assets/network";
import { uSimError } from "utils/override";

import { convertAndDownload } from "utils/csv";

const initialState = {
  loading: false,
  list: [],
  templateLoading: false,
  template: [],
  validationMessage: "",
  uploading: false,
};

export default function network(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_NETWORK_DOWNLOAD_TEMPLATE_REQUEST: {
      return {
        ...state,
        templateLoading: true,
        template: [],
      };
    }

    case GET_NETWORK_DOWNLOAD_TEMPLATE_SUCCESS: {
      convertAndDownload(payload, "financials");
      return {
        ...state,
        templateLoading: false,
        template: payload,
      };
    }

    case GET_NETWORK_DOWNLOAD_TEMPLATE_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        templateLoading: false,
        template: [],
      };
    }

    case GET_NETWORK_LIST_REQUEST:
    case DELETE_NETWORK_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case UPLOAD_NETWORK_DATA_REQUEST: {
      return {
        ...state,
        uploading: true,
      };
    }

    case GET_NETWORK_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: payload.map((it, i) => {
          return {
            ...it,
            id: i,
          };
        }),
      };
    }

    case DELETE_NETWORK_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case UPLOAD_NETWORK_DATA_SUCCESS: {
      return {
        ...state,
        uploading: false,
      };
    }

    case GET_NETWORK_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
        list: [],
      };
    }

    case DELETE_NETWORK_LIST_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        loading: false,
      };
    }

    case UPLOAD_NETWORK_DATA_FAILURE: {
      uSimError(payload?.message || "Something went wrong");
      return {
        ...state,
        uploading: false,
      };
    }

    default:
      return state;
  }
}
